import React from "react";
import PropTypes from "prop-types";

const RotateHandleIcon = ({ className, width, size, height, style, color }) => (
  <svg
    className={className}
    style={style}
    width={width || size || 16}
    height={height || size || 16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        stroke={color || "#2c2e2f"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 8a5 5 0 1 0-5 5"
      />
      <path
        stroke={color || "#2c2e2f"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m15 8-2 2-2-2"
      />
    </g>
  </svg>
);

RotateHandleIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  color: PropTypes.string
};

export default RotateHandleIcon;
